import { render } from "./OfficeCalendar.vue?vue&type=template&id=5a1de2e2"
import script from "./OfficeCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./OfficeCalendar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Internal/Calendar/OfficeCalendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a1de2e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a1de2e2', __exports__)) {
    api.reload('5a1de2e2', __exports__)
  }
  
  module.hot.accept("./OfficeCalendar.vue?vue&type=template&id=5a1de2e2", () => {
    api.rerender('5a1de2e2', render)
  })

}


export default __exports__